import React from 'react';
import './VehicleResult.scss';

const Local = [
    {
        question: 'What is included in the local rental price?',
        answer: `The price includes the vehicle, fuel and driver charges for the selected duration.`
    },
    {
        question: 'How is the price calculated for local bookings?',
        answer: 'Prices are based on preset time and distance slabs (e.g., 2 hrs / 20 kms), starting from 9:00 AM the next calendar day.'
    },
    {
        question: 'Can I customize my booking with extras?',
        answer: 'Yes, you can add options like a flower decoration, goodies, or extra hours. Prices update instantly.'
    },
    {
        question: 'Can I change the pickup time or location?',
        answer: 'Yes, you can edit the pickup time or location at the top of the result page.'
    },
    {
        question: 'What happens if I exceed the selected duration or distance?',
        answer: 'Extra charges will apply as per the hourly or km rate mentioned on the booking page.'
    }
];

const Outstation = [
    {
        question: 'How is outstation pricing calculated?',
        answer: 'Pricing depends on your selected route, distance, and whether it’s a one-way or round trip. Default start time is 9:00 AM the next day.'
    },
    {
        question: 'How is the round trip duration decided?',
        answer: 'Round trips are usually counted for 2 days. For example, if your trip starts on the 21st, it’s assumed to end on the 23rd.'
    },
    {
        question: 'Can I customize the trip or add services?',
        answer: 'Yes, add-ons like food baskets or extra hours can be selected to tailor your journey.'
    },
    {
        question: 'Can I adjust trip dates or vehicle preferences?',
        answer: 'Absolutely. Use the short form at the top to change dates, car model, or trip type.'
    },
    {
        question: 'Is toll and parking included in the price?',
        answer: 'No, Toll and parking charges are not included in the displayed price.'
    }
];

const Faq = ({ tripType = 'local' }) => {
    const faqList = tripType === 'outstation' ? Outstation : Local;

    return (
        <div className="faq mb-5">
            <h6 className="text-muted">FAQs</h6>
            <h3 className="font-weight-bold mb-4 charcol-grey">Things We Often Get Asked</h3>
            <div id="accordion">
                {faqList.map((item, index) => (
                    <div className="card" key={index}>
                        <div className="card-header" id={`heading${index}`}>
                            <h5 className="mb-0 d-flex justify-content-between align-items-center">
                                <button
                                    className={`btn btn-link faq-toggle ${index !== 0 ? 'collapsed' : ''}`}
                                    data-toggle="collapse"
                                    data-target={`#collapse${index}`}
                                    aria-expanded={index === 0}
                                    aria-controls={`collapse${index}`}
                                >
                                    {item.question}
                                </button>
                                {/* <span className="toggle-icon">{index === 0 ? '−' : '+'}</span> */}
                            </h5>
                        </div>
                        <div
                            id={`collapse${index}`}
                            className={`collapse ${index === 0 ? 'show' : ''}`}
                            aria-labelledby={`heading${index}`}
                            data-parent="#accordion"
                        >
                            <div className="card-body">{item.answer}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Faq;
